import { createUserOnboardingStartMutation } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useUserOnboardingStartMutation = createUserOnboardingStartMutation(HTTP_CONFIG.API.Consumer.url)
